import React, { useState, useEffect, useRef } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import PrintIcon from "@mui/icons-material/Print";
import { Button, Modal, Col, Row, Card } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import { useNavigate, useLocation, Link } from "react-router-dom";
// import QRCode from "react-qr-code";
import { QRCode } from "react-qrcode-logo";
import { TextField } from "@mui/material";
import SwalMessage from "../../_Components/SwalMessage";
import html2canvas from "html2canvas";
import ReactToPrint from "react-to-print";
import jsPDF from "jspdf";

export const QrPromoCodeModal = ({
  showModalQrPromoCode,
  setShowModalQrPromoCode,
  selectedQrCode,
}) => {
  let location = useLocation();
  let navigate = useNavigate();

  const promoCode = selectedQrCode;

  // const { match } = props;
  // let params = match.params;
  const [copySuccess, setCopySuccess] = useState(null);
  const [codeCopySuccess, setCodeCopySuccess] = useState(null);
  const [modalHide, setmodalHide] = useState(true);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    getValues,
    setValue,
  } = useForm({
    defaultValues: {
      urlAddress: "https://www.tafrihan.com/?prc=" + promoCode,
      code: promoCode,
    },
  });
  let handleClose = (e) => {
    // if (!_.isUndefined(props?.promoCodeProp) && props?.promoCodeProp!=null){
    //setmodalHide(false);
    // } else {
    //     navigate(-1);}

    // props.callback();
    setShowModalQrPromoCode(false);
  };
  useEffect(() => {
    (async () => {
      try {
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => {};
  }, []);
  const copyToClipBoard = async (copyMe) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess("Copied!");
      SwalMessage({
        title: "آدرس کد تخفیف کپی شد",
        iSsuccess: true,
        timer: 10000,
      });
    } catch (err) {
      setCopySuccess("Failed to copy!");
    }
  };
  const codeCopyToClipBoard = async (copyMe) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      setCodeCopySuccess("Copied!");
      SwalMessage({ title: "کد تخفیف کپی شد", iSsuccess: true, timer: 10000 });
    } catch (err) {
      setCodeCopySuccess("Failed to copy!");
    }
  };

  // const generatePDF = () => {
  //   const element = document.getElementById("content-to-print");
  //   const options = {
  //     margin: [5, 5],
  //     filename: "documentw.pdf",
  //     image: { type: "jpg", quality: 0.9 },
  //     html2canvas: { scale: 2 },
  //     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //   };

  //   html2pdf().from(element).set(options).save();
  // };
  const componentRef = useRef();
  const data = [
    {
      id: 1,
      amusementName: "پاراسل",
      imgUrl: "amusement/parasel1.jpg",
    },
    {
      id: 2,
      amusementName: "کشتی اوستا",
      imgUrl: "amusement/privatecruiseship17003.jpg",
    },
    {
      id: 3,
      amusementName: "جنگ شبانه",
      imgUrl: "amusement/rangarang.jpg",
    },
    {
      id: 4,
      amusementName: "پارک آبی اوشن",
      imgUrl: "amusement/oceanwaterpark1029.jpg",
    },
    {
      id: 4,
      amusementName: "پارک  دلفین",
      imgUrl: "amusement/dolphinpark.jpg",
    },
  ];

  const printRef = useRef();

  // تابعی که از بخش مشخصی اسکرین‌شات می‌گیرد
  const captureAndPrint = () => {
    html2canvas(printRef.current, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const iframe = document.createElement("iframe");

      document.body.appendChild(iframe);

      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write("<html><head><title>Print</title></head><body>");

      iframeDoc.write(`
        <img src="${imgData}" style="width:100%;height:auto;"/>
      `);

      iframeDoc.write("</body></html>");
      iframeDoc.close();

      iframe.onload = function () {
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      };
    });
  };
  const GoToPrint = (promoCode) => {
    navigate("/printPromoCode", { state: { qrCode: promoCode } });
  };

  return (
    <div>
      <Modal
        centered
        size="md"
        show={showModalQrPromoCode}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>اطلاعات کد تخفیف </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className=" mx-auto">
            {/* <ReactToPrint
              trigger={() => (
                <Button variant="primary" className="">
                  چاپ
                </Button>
              )}
              content={() => componentRef.current}
            /> */}
          </div>
          {/* <div className="mt-3 border rounded-3 bg-white pb-3 mx-auto main-print-body">
            <div
              className="rtl line-height-1 react-to-print"
              id="content-to-print"
              ref={componentRef}
            >
              <div className="d-flex justify-content-center">
                <img
                  src="/media/logos/logo-s1.png"
                  alt=""
                  className="mx-auto pb-4"
                  style={{ width: "150px" }}
                />
              </div>
              <div className="d-flex justify-content-center flex-wrap">
                {data.map((item, index) => (
                  <Card
                    key={index}
                    className="rounded-4 text-center border bg-light mr-2 mb-2"
                    style={{ width: "120px" }}
                  >
                    <Card.Img
                      className="rounded-4 rounded-bottom-0"
                      variant="top"
                      src={item.imgUrl}
                      style={{ height: "91px" }}
                    />
                    <Card.Body className="px-1 py-1">
                      <Card.Text className="font-size-sm">
                        {item.amusementName}
                      </Card.Text>
                    </Card.Body>
                    <Card.Footer className="fw-bold text-danger border-top-0 bg-transparent font-size-lg px-1 py-1">
                      تخفیف ویژه
                    </Card.Footer>
                  </Card>
                ))}
              </div>
              <Row className="mt-3 ">
                <Col className="text-center my-auto position-relative">
                  <div className="pt-5">
                    <QRCode
                      size={140}
                      value={getValues("urlAddress")}
                      //logoImage={"https://www.tafrihan.com/static/media/logo-s1.ed56196b.png"}
                      //removeQrCodeBehindLogo={true}
                      logoOpacity={100}
                      logoWidth={90}
                      logoHeight={60}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                    ></QRCode>
                  </div>
                  <div className="text-center" style={{ fontSize: "15px" }}>
                    <div className="pb-1">1.بارکد را اسکن نمایید.</div>
                    <div className="mx-auto" style={{ width: "180px" }}>
                      2. با شماره 09100000000 وارد پنل کاربری خود شوید.
                    </div>
                    <div className="pb-1">3.سبد خرید را ایجاد نمایید.</div>
                    <div>4.کد تخفیف را وارد نمایید.</div>
                  </div>
                  <div className="px-5 py-0 rounded-3 d-inline-block fw-bold latin-text mt-3 mb-5">
                    {promoCode}
                  </div>
                  <div
                    className="mx-auto"
                    style={{ width: "150px", fontSize: "15px" }}
                  >
                    توجه فرمایید جهت استفاده از کد تخفیف فوق حتما باید در سایت
                    با شماره 091000000 وارد شده باشید.{" "}
                  </div>
                  <div className="fw-bold text-black mt-5">
                    <div className="pb-1">www.tahrihan.com</div>
                    <div className="pb-1">شماره تماس :07644100000 </div>
                    <div>شماره پشتیبانی : 09199781891</div>
                  </div>

                </Col>
                <Col md="6" className="text-center position-relative">
                  <img
                    src="/media/bg/promoCode.jpg"
                    alt="promo code"
                    width={230}
                  />
                  <div className="code-on-pic">{promoCode}</div>
                </Col>
              </Row>
            </div>
          </div> */}

          <div>
            {/* این دکمه برای گرفتن اسکرین‌شات و چاپ کردن آن */}
            {/* <button onClick={captureAndPrint}>چاپ اسکرین‌شات</button> */}

            {/* محتوای که می‌خواهید از آن اسکرین‌شات بگیرید */}
            {/* <div ref={printRef} style={{ padding: "20px", width: "100%" }}>
              <div className="rtl line-height-1 react-to-print">
                <div className="d-flex justify-content-center">
                  <img
                    src="/media/logos/logo-s1.png"
                    alt=""
                    className="mx-auto pb-4"
                    style={{ width: "150px" }}
                  />
                </div>
                <div className="d-flex justify-content-center flex-wrap">
                  {data.map((item, index) => (
                    <Card
                      key={index}
                      className="rounded-4 text-center border bg-light mr-2 mb-2"
                      style={{ width: "120px" }}
                    >
                      <Card.Img
                        className="rounded-4 rounded-bottom-0"
                        variant="top"
                        src={item.imgUrl}
                        style={{ height: "91px" }}
                      />
                      <Card.Body className="px-1 py-1">
                        <Card.Text className="font-size-sm">
                          {item.amusementName}
                        </Card.Text>
                      </Card.Body>
                      <Card.Footer className="fw-bold text-danger border-top-0 bg-transparent font-size-lg px-1 py-1">
                        تخفیف ویژه
                      </Card.Footer>
                    </Card>
                  ))}
                </div>
                <Row className="mt-3 ">
                  <Col className="text-center my-auto position-relative">
                    <div className="pt-5">
                      <QRCode
                        size={140}
                        value={getValues("urlAddress")}
                        logoOpacity={100}
                        logoWidth={90}
                        logoHeight={60}
                        style={{
                          height: "auto",
                          maxWidth: "100%",
                          width: "100%",
                        }}
                      ></QRCode>
                    </div>

                    <div className="text-center" style={{ fontSize: "15px" }}>
                      <div className="pb-1">1.بارکد را اسکن نمایید.</div>
                      <div className="mx-auto" style={{ width: "180px" }}>
                        2. با شماره 09100000000 وارد پنل کاربری خود شوید.
                      </div>
                      <div className="pb-1">3.سبد خرید را ایجاد نمایید.</div>
                      <div>4.کد تخفیف را وارد نمایید.</div>
                    </div>
                    <div className="px-5 py-0 rounded-3 d-inline-block fw-bold latin-text mt-3 mb-5">
                      {promoCode}
                    </div>
                    <div className="mx-auto" style={{ width: "150px" }}>
                      توجه فرمایید جهت استفاده از کد تخفیف فوق حتما باید در سایت
                      با شماره 091000000 وارد شده باشید.{" "}
                    </div>
                    <div className="fw-bold text-black mt-5">
                      <div className="pb-1">www.tahrihan.com</div>
                      <div className="pb-1">شماره تماس :07644100000 </div>
                      <div>شماره پشتیبانی : 09199781891</div>
                    </div>
                  </Col>
                  <Col lg="6" className="text-center position-relative">
                    <img
                      src="/media/bg/promoCode.jpg"
                      alt="promo code"
                      width={290}
                    />
                    <div className="code-on-pic">{promoCode}</div>
                  </Col>
                </Row>
              </div>
            </div> */}
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <QRCode
              size={200}
              value={getValues("urlAddress")}
              //logoImage={"https://www.tafrihan.com/static/media/logo-s1.ed56196b.png"}
              //removeQrCodeBehindLogo={true}
              logoOpacity={100}
              logoWidth={90}
              logoHeight={60}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            ></QRCode>
          </div>
          <Col sm="10" className="mx-auto">
            <Controller
              name="urlAddress"
              control={control}
              render={({ field: { onChange, value } }) => (
                <div className="d-flex align-items-center">
                  <TextField
                    label="ادرس سایت به همراه با کد تخفیف"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    disabled
                    className="ltr"
                  />

                  <span
                    className="btn btn-light-primary btn-sm mr-2 btn-icon mt-2 ml-2 "
                    onClick={(e) => copyToClipBoard(getValues("urlAddress"))}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-custom-class="tooltip-dark"
                    title="کپی تو کلیپ بورد"
                    data-bs-delay-hide="1000"
                  >
                    <i class="fas fa-clipboard"></i>
                  </span>
                </div>
              )}
            />
          </Col>

          <Col sm="10" className="mx-auto">
            <Controller
              name="code"
              control={control}
              render={({ field: { onChange, value } }) => (
                <div className="d-flex align-items-center">
                  <TextField
                    label="کد تخفیف"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    disabled
                    className="ltr"
                  />

                  <span
                    className="btn btn-light-primary btn-sm mr-2 btn-icon mt-2 ml-2 "
                    onClick={(e) => codeCopyToClipBoard(getValues("code"))}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-custom-class="tooltip-dark"
                    title="کپی تو کلیپ بورد"
                    data-bs-delay-hide="1000"
                  >
                    <i class="fas fa-clipboard"></i>
                  </span>
                </div>
              )}
            />
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => GoToPrint()}>
            <PrintIcon className="mr-1" />
            مشاهده و چاپ
          </Button>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon className="mr-1" /> بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
